import React from 'react';

const Ambient = () => {
  return (
    <>
      {/* Grain Overlay */}
      <div className="grain-overlay" />
      
      {/* Ambient Orb - Hero only, will be positioned in hero */}
      {/* Note: Orb positioning handled per-page in hero section */}
    </>
  );
};

export default Ambient;
